import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { managedCompaniesSelector } from '../Settings/store/SettingsSelectors'
import ImportUsersAdmin, { IImportUsersAdminProps, IImportUsersAdminDispatchProps } from './ImportUsersAdmin'
import { importUsers, clearImportUsersResult } from './store/ImportUsersAdminActions'
import { getImportUsersUploading, getImportUsersResult } from './store/ImportUsersAdminSelectors'
import { getCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminSelectors'
import { setCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminActions'

const mapStateToProps = (state: IGlobalState): IImportUsersAdminProps => ({
  managedCompanies: managedCompaniesSelector(state),
  uploading: getImportUsersUploading(state),
  result: getImportUsersResult(state),
  selectedCompanyId: getCompanyAdminSelectedCompanyId(state),
})

const mapDispatchToProps: IImportUsersAdminDispatchProps = {
  importUsers,
  clearImportUsersResult,
  setSelectedCompanyId: setCompanyAdminSelectedCompanyId,
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportUsersAdmin)
